import { IBarcode } from '@app/models/barcode.interface';
import { IReport } from '@app/models/report.interface';
import { createAction, props } from '@ngrx/store';

export const loadReports = createAction(
  '[Reports] Load Reports',
  props<any>()
);

export const loadReportsSuccess = createAction(
  '[Reports] Load Reports Success',
  props<{ reports: IReport[], total: number }>()
);

export const loadReportsFailure = createAction(
  '[Reports] Load Reports Failure',
  props<{ error: any }>()
);

export const loadPicked = createAction(
  '[Reports] Load Picked',
  props<any>()
);

export const loadPickedSuccess = createAction(
  '[Reports] Load Picked Success',
  props<{ picked: IReport[], picked_total: number }>()
);

export const loadPickedFailure = createAction(
  '[Reports] Load Picked Failure',
  props<{ error: any }>()
);

export const loadPickActivity = createAction(
  '[Reports] Load Pick Activity',
  props<any>()
);

export const loadPickActivitySuccess = createAction(
  '[Reports] Load Pick Activity Success',
  props<{ pickActivity: any[], pickActivity_total: number }>()
);

export const loadPickActivityFailure = createAction(
  '[Reports] Load Pick Activity Failure',
  props<{ error: any }>()
);

export const loadProductSerialNumber = createAction(
  '[Reports] Load Product Serial Number',
  props<any>()
);

export const loadProductSerialNumberSuccess = createAction(
  '[Reports] Load Product Serial Number Success',
  props<{ productSerialNumber: IReport[], product_serialnumber_total: number }>()
);

export const loadProductSerialNumberFailure = createAction(
  '[Reports] Load Product Serial Number Failure',
  props<{ error: any }>()
);

export const loadReorder = createAction(
  '[Reports] Load Reorder',
  props<any>()
);

export const loadReorderSuccess = createAction(
  '[Reports] Load Reorder Success',
  props<{ reorder: IReport[], reorder_total: number }>()
);

export const loadReorderFailure = createAction(
  '[Reports] Load Reorder Failure',
  props<{ error: any }>()
);

export const loadReceived = createAction(
  '[Reports] Load Received',
  props<any>()
);

export const loadReceivedSuccess = createAction(
  '[Reports] Load Received Success',
  props<{ received: IReport[], received_total: number }>()
);

export const loadReceivedFailure = createAction(
  '[Reports] Load Received Failure',
  props<{ error: any }>()
);


export const filterByCategory = createAction(
  '[Reports] Filter Reports By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Reports] Filter Reports By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Reports] Filter Reports By Category Failure',
  props<{ error: any }>()
);

export const filterByReorderCategory = createAction(
  '[Reports] Filter Reports By Reorder Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByReorderCategorySuccess = createAction(
  '[Reports] Filter Reports By Reorder Category Success',
  props<any>()
);

export const filterByReorderCategoryFailure = createAction(
  '[Reports] Filter Reports By Reorder Category Failure',
  props<{ error: any }>()
);

export const filterByStorages = createAction(
  '[Reports] Filter Reports By Storages',
  props<{ prdStoragesIDs: any, active: string, direction: string }>()
);

export const filterByStoragesSuccess = createAction(
  '[Reports] Filter Reports By Storages Success',
  props<any>()
);

export const filterByStoragesFailure = createAction(
  '[Reports] Filter Reports By Storages Failure',
  props<{ error: any }>()
);

export const filterReorderByStorages = createAction(
  '[Reports] Filter Reorder Reports By Storages',
  props<{ prdStoragesIDs: any, active: string, direction: string }>()
);

export const filterReorderByStoragesSuccess = createAction(
  '[Reports] Filter Reorder Reports By Storages Success',
  props<any>()
);

export const filterReorderByStoragesFailure = createAction(
  '[Reports] Filter Reorder Reports By Storages Failure',
  props<{ error: any }>()
);

export const loadReport = createAction(
  '[Reports] Load Report',
  props<{ prdID: any }>()
);

export const loadReportSuccess = createAction(
  '[Reports] Load Report Success',
  props<{ report: any }>()
);

export const loadReportFailure = createAction(
  '[Reports] Load Report Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Reports] Search',
  props<{ query: string }>()
);

export const searchSuccess = createAction(
  '[Reports] Search Success',
  props<{ reports: IReport[], total: number}>()
);

export const searchFailure = createAction(
  '[Reports] Search Failure',
  props<{ error: any }>()
);


export const searchPicked = createAction(
  '[Reports] Search Picked',
  props<{ query: string }>()
);

export const searchPickedSuccess = createAction(
  '[Reports] Search Picked Success',
  props<{ picked: IReport[], picked_total: number}>()
);

export const searchPickedFailure = createAction(
  '[Reports] Search Picked Failure',
  props<{ error: any }>()
);

export const searchProductSerialNumber = createAction(
  '[Reports] Search ProductSerialNumber',
  props<{ query: string, prdID:any }>()
);

export const searchProductSerialNumberSuccess = createAction(
  '[Reports] Search ProductSerialNumber Success',
  props<{ productSerialNumber: IReport[], product_serialnumber_total: number}>()
);

export const searchProductSerialNumberFailure = createAction(
  '[Reports] Search ProductSerialNumber Failure',
  props<{ error: any }>()
);

export const searchReceived = createAction(
  '[Reports] Search Received',
  props<{ query: string }>()
);

export const searchReceivedSuccess = createAction(
  '[Reports] Search Received Success',
  props<{ received: IReport[], received_total: number}>()
);

export const searchReceivedFailure = createAction(
  '[Reports] Search Received Failure',
  props<{ error: any }>()
);


export const searchReorder = createAction(
  '[Reports] Search Reorder',
  props<{ query: string }>()
);

export const searchReorderSuccess = createAction(
  '[Reports] Search Reorder Success',
  props<{ reorder: IReport[], reorder_total: number}>()
);

export const searchReorderFailure = createAction(
  '[Reports] Search Reorder Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Reports] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Reports] Reset Pagination'
);

export const resetReports = createAction(
  '[Reports] Reset Reports'
);

export const incrementPageSuccess = createAction(
  '[Reports] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Reports] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Reports] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Reports] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Reports] Set Filter Type',
  props<{ filterType: string, filterID: any }>()
);

export const setSelected = createAction(
  '[Reports] Set Selected',
  props<{ selected: any }>()
);
export const setPickedSelected = createAction(
  '[Reports] Set Picked Selected',
  props<{ pickedSelected: any }>()
);
export const setProductSerialNumberSelected = createAction(
  '[Reports] Set ProductSerialNumber Selected',
  props<{ productSerialNumberSelected: any }>()
);
export const setReceivedSelected = createAction(
  '[Reports] Set Picked Selected',
  props<{ receivedSelected: any }>()
);

export const setReorderSelected = createAction(
  '[Reports] Set Reorder Selected',
  props<{ reorderSelected: any }>()
);

export const setSort = createAction(
  '[Reports] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const setReorderSort = createAction(
  '[Reports] Set Reorder Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const setPickedSort = createAction(
  '[Reports] Set Picked Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const setProductSerialNumberSort = createAction(
  '[Reports] Set ProductSerialNumber Sort',
  props<{ sort: string, direction: string, query: string, prdID:any }>()
);

export const setReceivedSort = createAction(
  '[Reports] Set Received Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetReport = createAction(
  '[Reports] Reset Report'
);

export const resetFilter = createAction(
  '[Reports] Reset Filter'
)

export const setDeselected = createAction(
  '[Reports] Set Deselected'
);
export const setPickedDeselected = createAction(
  '[Reports] Set Picked Deselected'
);
export const setReceivedDeselected = createAction(
  '[Reports] Set Picked Deselected'
);
export const setReorderDeselected = createAction(
  '[Reports] Set Reorder Deselected'
);

export const exportReports = createAction(
  '[Reports] Export Reports'
);

export const sortByCategory = createAction(
  '[Reports] Sort By Category Reports',
  props<{ active: string, direction:string, category: number }>()
);

export const sortByCategorySuccess = createAction(
  '[Reports] Sort By Category Reports Success',
  props<any>()
);

export const onOverride = createAction(
  '[Reports] Override Reports Success',
  props<any>()
);

export const sortByCategoryFailure = createAction(
  '[Reports] Sort By Category Reports Failure',
  props<{ error: any }>()
);

export const setIsLoading = createAction(
  '[Reports] Set Is Loading',
  props<{ isLoading: boolean }>()
);

